import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Spinner,
  Tabs,
  Tab,
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";

import { useSelector } from "react-redux";
import { selectUser } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";

import ReconSummaryGrid from "../../components/GST/ReconSummaryGrid";
import MatchResultsGrid from "../../components/GST/MatchResultsGrid";
import ManualMatchPanel from "../../components/GST/ManualMatchPanel";
import GroupMatchModal from "../../components/GST/GroupMatchModal";
import VendorSummaryGrid from "../../components/GST/VendorSummaryGrid";
import VendorMatchPopup from "../../components/GST/VendorMatchPopup";

const GstReconWorkspace = ({ initialProcessMonth = "" }) => {
  const user = useSelector(selectUser);
  const emp_id = user?.emp_id;
  const token = user?.token;
  const navigate = useNavigate();

  const monthOptions = [
    "JAN-2025","FEB-2025","MAR-2025","APR-2025","MAY-2025","JUN-2025",
    "JUL-2025","AUG-2025","SEP-2025","OCT-2025","NOV-2025","DEC-2025"
  ];

  const entityOptions = [
    { code: "SE", name: "Singhal Steel & Power Pvt Ltd" },
    { code: "SS", name: "Shyam ISAP Pvt Ltd" }
  ];
  const [entity, setEntity] = useState("");
  const [loading, setLoading] = useState(false);

  /* 🔑 ENTITY CONTEXT (DERIVED FROM USER) */
  const entityCode =
    user?.entity_code ||
    user?.hr_entity_code ||
    user?.default_entity ||
    null;

  const [processMonth, setProcessMonth] = useState(initialProcessMonth);

  const [summary, setSummary] = useState([]);
  const [matches, setMatches] = useState([]);
  const [unmatchedErp, setUnmatchedErp] = useState([]);
  const [unmatched2b, setUnmatched2b] = useState([]);

  const [loadingSummary, setLoadingSummary] = useState(false);
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [loadingManual, setLoadingManual] = useState(false);

  const [activeMatchFilter, setActiveMatchFilter] = useState(null);
  const [activeTab, setActiveTab] = useState("matches");

  const [groupModalOpen, setGroupModalOpen] = useState(false);
  const [groupDetails, setGroupDetails] = useState(null);

  const [summaryCollapsed, setSummaryCollapsed] = useState(false);
  const [tabsCollapsed, setTabsCollapsed] = useState(false);

  const [activeVendorContext, setActiveVendorContext] = useState(null);
  const [vendorSummary, setVendorSummary] = useState([]);
  const [loadingVendorSummary, setLoadingVendorSummary] = useState(false);
  
  const [showVendorPopup, setShowVendorPopup] = useState(false);
  const [vendorPopupCtx, setVendorPopupCtx] = useState(null);
  const [vendorMatchData, setVendorMatchData] = useState([]);
  const [vendorMatchLoading, setVendorMatchLoading] = useState(false);
  
// MATCHED | VENDOR

  useEffect(() => {
    if (activeTab === "manual") setSummaryCollapsed(true);
    if (activeTab === "matches") setSummaryCollapsed(false);
  }, [activeTab]);

  const handleLoadRecon = async () => {
    if (!processMonth) {
      alert("Please enter Process Month (e.g. APR-2025)");
      return;
    }
    await Promise.all([
      loadSummary(processMonth, entity),
      loadMatches(processMonth, entity),
    ]);
  };

  const loadSummary = async (month, entity) => {
    try {
      setLoadingSummary(true);
      const res = await axios.post("/api/gst2b/getReconSummary",  
      { process_month: month,
        entity: entity }
      );
      setSummary(Array.isArray(res.data) ? res.data : []);
    } finally {
      setLoadingSummary(false);
    }
  };

  const loadMatches = async (month, entity) => {
    try {
      setLoadingMatches(true);
      const res = await axios.post("/api/gst2b/getReconMatchedResults", {
        process_month: month ,
        entity_code: entity
      });
      setMatches(res.data || []);
    } finally {
      setLoadingMatches(false);
    }
  };

  const loadVendorSummary = async (ctx) => {
    console.log("ctx:", ctx);
    if (!entity) {
      alert("Please select Entity");
      return;
    }
    
    try {
      setLoadingVendorSummary(true);
  
      const res = await axios.post("/api/gst2b/getVendorReconMatchedSummary", {
        process_month: ctx.process_month,
        entity_code: entity,
        match_type: ctx.matchType,
      });
      
      console.log(res);
      // ✅ Normal success
      setVendorSummary(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      // ✅ Backend wrongly returns 404 for "no data"
      if (err.response?.status === 404) {
        console.warn("No vendor summary found (treated as empty)");
        setVendorSummary([]);
      } else {
        // ❌ Real error – log it
        console.error("Vendor summary load failed:", err);
        alert("Failed to load Vendor Summary. Please retry.");
        setVendorSummary([]);
      }
    } finally {
      // ✅ Loader always stops
      setLoadingVendorSummary(false);
    }
  };
      
  const submitApproval = async (rows) => {
    if (!rows || rows.length === 0) return;
    console.log ("Payload-1:", rows);
  
    const payload = rows.map((r) => ({
      recon_id: r.ID,
      erp_purchase_id: r.ERP_PURCHASE_ID,
      gstr2b_id: r.GSTR2B_ID,
      match_type: r.MATCH_TYPE,
      match_score: r.MATCH_SCORE,
    }));
  
    console.log ("Payload:", payload);

    await axios.post("/api/gst2b/approveMatchedResults", {
      approvals: payload,
    });
  
    // Reload data after approval
    await Promise.all([
      loadSummary(processMonth, entity),
      loadMatches(processMonth, entity),
    ]);
  };

  const submitUnapproval = async (rows) => {
    if (!rows || rows.length === 0) return;
    console.log ("Payload-1:", rows);
  
    const payload = rows.map((r) => ({
      recon_id: r.ID,
      erp_purchase_id: r.ERP_PURCHASE_ID,
      gstr2b_id: r.GSTR2B_ID,
      match_type: r.MATCH_TYPE,
      match_score: r.MATCH_SCORE,
    }));
  
    console.log ("Payload:", payload);

    await axios.post("/api/gst2b/unapproveMatchedResults", {
      approvals: payload,
    });
  
    // Reload data after approval
    await Promise.all([
      loadSummary(processMonth, entity),
      loadMatches(processMonth, entity),
    ]);

  };

  const handleApprove = (row) => {
    submitApproval([row]);
  };
  const handleUnapprove = (row) => {
    submitUnapproval([row]);
  };

  const handleBulkApprove = (rows) => {
    submitApproval(rows);
  };

  const handleBulkUnapprove = (rows) => {
    submitUnapproval(rows);
  };

  const handleUnmatch = (row) => {
    submitUnmatch([row]);
  };

  const handleBulkUnmatch = (rows) => {
    submitUnmatch(rows);
  };
  
  //Vendor Summary View Action - Show corresponding matches grid //
  const handleVendorView = async (row) => {
    try {
      if (!entity) {
        alert("Please select Entity");
        return;
      }
      
      setVendorPopupCtx({
        GSTIN: row.GSTIN,
        PARTY_NAME_ERP: row.PARTY_NAME_ERP,
        PARTY_NAME_2B: row.PARTY_NAME_2B,
      });
  

      setShowVendorPopup(true);
      setVendorMatchLoading(true);
      setVendorMatchData([]);
  
      console.log("payload at VendoMatchDetails:",row.GSTIN,entity, processMonth,   activeVendorContext?.matchType || activeMatchFilter);

      const res = await axios.post(
        "/api/gst2b/getVendorMatchDetails",
        {
          gstin: row.GSTIN,
          entity_code: entity,                 // ✅ workspace source
          process_month: processMonth,         // ✅ workspace source
          match_type: activeVendorContext?.matchType 
                       || activeMatchFilter    // ✅ fallback-safe
        },
        { headers: { Authorization: `Bearer ${user?.token}` } }
      );
      console.log("Vendor match res:", res);
      setVendorMatchData(res.data || []);
    } catch (err) {
      console.error("Vendor match fetch failed", err);
      setVendorMatchData([]);
    } finally {
      setVendorMatchLoading(false);
    }
  };
  
  const submitUnmatch = async (rows) => {
    if (!rows || rows.length === 0) return;
  
    const payload = rows.map((r) => ({
      recon_id: r.ID,
    }));
  
    await axios.post("/api/gst2b/unmatchMatchedResults", {
      rows: payload,
    });
  
    await Promise.all([
      loadSummary(processMonth, entity),
      loadMatches(processMonth, entity),
    ]);
  };

  const openGroupPopup = (row) => {
    setGroupDetails(row);
    setGroupModalOpen(true);
  };
  
  if (!token)
    return (
      <div>
        <p>Please login.</p>
        <button onClick={() => navigate("/")}>Login</button>
      </div>
    );

  return (
    <Container fluid style={{ fontSize: "0.8rem" }}>
      {/* CONTROL BAR */}
      <Card className="mb-1 shadow-sm">
        <Card.Body style={{ padding: "4px 8px" }}>
          <Row className="align-items-center g-1">
            <Col md="auto">
              <div className="d-flex align-items-center gap-2">
                <Form.Label className="mb-0 small">
                  Period
                </Form.Label>

                <Form.Select
                  size="sm"
                  value={processMonth}
                  disabled={loading}
                  onChange={(e) => setProcessMonth(e.target.value)}
                  style={{ width: "140px" }}
                >
                  <option value="">-- Month --</option>
                  {monthOptions.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col md="auto">
              <div className="d-flex align-items-center gap-2">
                <Form.Label className="mb-0 small">
                  Entity
                </Form.Label>

                <Form.Select
                  size="sm"
                  value={entity}
                  disabled={loading}
                  onChange={(e) => setEntity(e.target.value)}
                  style={{ width: "240px" }}
                >
                  <option value="">-- Entity --</option>
                  {entityOptions.map((e) => (
                  <option key={e.code} value={e.code}>
                    {e.code} - {e.name}
                  </option>
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col md="auto">
              <Button
                size="sm"
                style={{ height: "28px" }}
                onClick={handleLoadRecon}
                disabled={!processMonth}
              >
                Load
              </Button>
            </Col>

            <Col />
          </Row>
        </Card.Body>
      </Card>

      {/* SUMMARY */}
      {!summaryCollapsed && (
        <ReconSummaryGrid
          summary={summary}
          processMonth={processMonth}
          entityCode={entityCode}
          onVendorSummarySelect={(ctx) => {
            setActiveVendorContext(ctx);
            setActiveTab("vendors");      // 🔥 switch tab
            loadVendorSummary(ctx);      // 🔥 load data
          }}
        
          onSelect={(matchType) => {
            setActiveTab("matches");
            setActiveMatchFilter(matchType);
            setSummaryCollapsed(false);
            setTabsCollapsed(false);
          }}
        />
      )}

      {loadingSummary && (
        <div className="text-center py-1">
          <Spinner animation="border" size="sm" />
        </div>
      )}

      {/* DETAILS */}
      <Card className="mt-1 shadow-sm">
        <Card.Body style={{ padding: "6px 8px" }}>
          <Row className="align-items-center mb-1">
            <Col className="fw-bold small">Details</Col>
            <Col className="text-end">
              <Button
                size="sm"
                variant="outline-secondary"
                style={{ fontSize: "0.7rem", height: "24px" }}
                onClick={() => setTabsCollapsed((v) => !v)}
              >
                {tabsCollapsed ? "Expand ▲" : "Collapse ▼"}
              </Button>
            </Col>
          </Row>

          {!tabsCollapsed && (
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k || "matches")}
              style={{ fontSize: "0.78rem" }}
            >
              <Tab eventKey="matches" title="Matches">
                {loadingMatches ? (
                  <Spinner size="sm" />
                ) : (
                  <MatchResultsGrid
                    data={
                      activeMatchFilter
                        ? matches.filter((m) => m.MATCH_TYPE === activeMatchFilter)
                        : matches
                    }
                    onApprove={handleApprove}
                    onUnapprove={handleUnapprove}
                    onBulkApprove={handleBulkApprove}
                    onBulkUnpprove={handleBulkUnapprove}
                    onUnmatch={handleUnmatch}
                    onBulkUnmatch={handleBulkUnmatch}
                    onOpenGroup={openGroupPopup}                  
                    compact
                  />
                )}
              </Tab>
              {/* ✅ NEW TAB PLACEHOLDER */}
              <Tab eventKey="vendors" title="Vendor Summary">
                <VendorSummaryGrid
                  data={vendorSummary}
                  loading={loadingVendorSummary}
                  onView={handleVendorView}   // 🔥 THIS WAS MISSING
                />
              </Tab>

              <Tab eventKey="manual" title="Manual Matching">
                <ManualMatchPanel
                  processMonth={processMonth}
                  emp_id={emp_id}
                  unmatchedErp={unmatchedErp}
                  unmatched2b={unmatched2b}
                  compact
                />
              </Tab>
            </Tabs>
          )}
        </Card.Body>
      </Card>

      <GroupMatchModal
        show={groupModalOpen}
        onHide={() => setGroupModalOpen(false)}
        group={groupDetails}
      />
      <VendorMatchPopup
        show={showVendorPopup}
        onClose={() => setShowVendorPopup(false)}
        vendor={vendorPopupCtx}
        data={vendorMatchData}
      />

    </Container>
  );
};

export default GstReconWorkspace;
